import React from 'react';
import {
  Paper,
  Stack,
  TextField,
  InputAdornment,
  Button,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function HealthFilterBar({
  searchQ,
  onSearchQChange,
  onSearch,
  from,
  to,
  onFromChange,
  onToChange,
  onClearDates,
  reportTypeFilter,
  onReportTypeFilterChange,
  reportTypes,
  loading,
  showReportTypeChips,
}) {
  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ sm: 'center' }}>
          <TextField
            size="small"
            placeholder="Search file name, report type, hospital, type, tags…"
            value={searchQ}
            onChange={(e) => onSearchQChange(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onSearch()}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{ flex: 1, minWidth: 160 }}
          />
          <Button size="small" variant="outlined" onClick={onSearch} disabled={loading}>
            Search
          </Button>
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ sm: 'center' }} flexWrap="wrap" useFlexGap>
          <TextField
            size="small"
            label="From"
            type="date"
            value={from}
            onChange={(e) => onFromChange(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: { xs: '100%', sm: 160 } }}
          />
          <TextField
            size="small"
            label="To"
            type="date"
            value={to}
            onChange={(e) => onToChange(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: { xs: '100%', sm: 160 } }}
          />
          {(from || to) && (
            <Button size="small" onClick={onClearDates}>
              Clear dates
            </Button>
          )}
        </Stack>
        {showReportTypeChips && reportTypes.length > 0 && (
          <Stack direction="row" flexWrap="wrap" gap={0.5}>
            <Chip
              label="All report types"
              size="small"
              variant={reportTypeFilter === 'all' ? 'filled' : 'outlined'}
              onClick={() => onReportTypeFilterChange('all')}
            />
            {reportTypes.map((t) => (
              <Chip
                key={t}
                label={t}
                size="small"
                variant={reportTypeFilter === t ? 'filled' : 'outlined'}
                onClick={() => onReportTypeFilterChange(t)}
              />
            ))}
          </Stack>
        )}
        {!showReportTypeChips && reportTypes.length > 0 && (
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel>Report type</InputLabel>
            <Select
              value={reportTypeFilter}
              label="Report type"
              onChange={(e) => onReportTypeFilterChange(e.target.value)}
            >
              <MenuItem value="all">All report types</MenuItem>
              {reportTypes.map((t) => (
                <MenuItem key={t} value={t}>
                  {t}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Stack>
    </Paper>
  );
}
